/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Requires
window.$ = window.jQuery = require('jquery');
import 'gasparesganga-jquery-loading-overlay';
// import Alpine from 'alpinejs';

// Import dependecies
import 'bootstrap';
import axios from 'axios';
import Qs from 'qs';
import 'flickity-as-nav-for';
import MarkerClusterer from 'markerclustererplus-ie11';

// Import custom modules
import fizzyUIUtils from 'fizzy-ui-utils';
import Flickity, { data } from 'flickity';
import bounty from 'bounty';
import noUiSlider from 'nouislider';

const elementsExists = (element) => {

	if ('undefined' != typeof (element) && null != element) {
		return true;
	}

	return false;
};

// IE 11 workarounds
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

let scrollPosition = window.scrollY;
let lastScrollPosition = scrollPosition;
let scrollTimeout = false;
let resizeTimeout;
let supportsTouch = 'ontouchstart' in window;
let touchscreenClass = 'not-touchscreen';
let body = document.body;
let headerHeight = document.querySelector('.site-header').offsetHeight;
let menuItems = document.querySelectorAll('.navbar-nav .dropdown');
let siteSearchInput = document.getElementById('s');
let siteSearchReset = document.querySelector('.site-search-reset');
let hero = document.querySelector('.block-hero');
let carousel = document.querySelector('.carousel');
let imageCarousels = document.querySelectorAll('.image-carousel');
let odometer = document.querySelector('.block-odometer');
let faqs = document.querySelectorAll('.faq-body-content');
let financialDropdown = document.querySelectorAll('.cm-mobile-main');
let flckty;
let rangeSliders = document.querySelectorAll('.range-slide');
let objectsList = document.querySelector('.object-filters');
let newsList = document.querySelector('.news-filter');
let objectsLayout = 'grid';
let gridLayoutToggle = document.querySelector('.toggle-objects-grid-layout');
let listLayoutToggle = document.querySelector('.toggle-objects-list-layout');
let objectsMapWrapper = document.querySelector('.objects-map-wrapper');
let propertyMap = document.querySelector('.property-map-wrapper');
let page = 1;
let filtering = false;

jQuery(document).ready(function(){
		console.log();
		
	// window.Alpine = Alpine;
  // Alpine.start();

	jQuery(document).on('gform_confirmation_loaded', function(event, formId){
		console.log(formId);
		if(formId == 7) {
			$("#gf_" + formId).closest('.col-lg-12').find('.text-title').hide()
			$('.bg-light-green').find('.container').hide();
			$(".block.block-newsletter.text-center.my-5.my-lg-6").css("display", "block");
			
			// $(".block.block-newsletter.text-center.my-5.my-lg-6") > $(".container") > $(".row") > $(".col-lg-6") > $(".title.text-title")
			// 	$(".title.text-title").css("display", "block");
			
		}
	});
})

document.querySelectorAll('.search-wrapper').forEach(function (wrapper) {
  var searchInput = wrapper.querySelector('.search-input');
  var linkList = wrapper.querySelector('.link-list');
  var lis = linkList.getElementsByTagName('li');

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const input = this.value.toLowerCase();
      let firstMatchFound = false;

      if (input.length > 0) {
        linkList.style.display = 'block'; // Visa listan
        Array.from(lis).forEach((li) => {
          if (li.textContent.toLowerCase().includes(input)) {
            li.style.display = ''; // Visa matchande element
            if (!firstMatchFound) {
              // Ta bort tidigare markerade
              const previousSelected = wrapper.querySelector('li.selected');
              if (previousSelected) {
                previousSelected.classList.remove('selected');
              }
              // Markera som vald
              li.classList.add('selected');
              firstMatchFound = true; // Sätt flaggan att första träffen är funnen
            }
          } else {
            li.style.display = 'none'; // Göm icke-matchande element
            li.classList.remove('selected'); // Ta bort 'selected' om det inte matchar
          }
        });
      } else {
        linkList.style.display = 'none'; // Göm listan om inget är skrivet
        Array.from(lis).forEach((li) => li.classList.remove('selected')); // Rensa alla 'selected'
      }
    });

    searchInput.addEventListener('focus', function () {
      linkList.style.display = 'block'; // Visa listan vid focus
    });

    searchInput.addEventListener('blur', function () {
      setTimeout(() => {
        linkList.style.display = 'none'; // Göm listan vid blur
      }, 200);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        const selected = wrapper.querySelector('li.selected a');
        if (selected) {
          window.location.href = selected.href; // Navigera till länken
        }
        e.preventDefault(); // Förhindra att sidan försöker skicka ett formulär
      }
    });
  }
});


$(function () {
  let droppedFiles = false;
  let $form = $('#gform_browse_button_7_28');

  $form
    // .addClass( 'has-advanced-upload' ) // letting the CSS part to know drag&drop is supported by the browser
    .on(
      'drag dragstart dragend dragover dragenter dragleave drop',
      function (e) {
        // preventing the unwanted behaviours
        // e.preventDefault();
        // e.stopPropagation();
      }
    )
    .on('dragover dragenter', function () //
    {
      $form.addClass('is-dragover');
    })
    .on('dragleave dragend drop', function () {
      $form.removeClass('is-dragover');
    })
    .on('drop', function (e) {
      droppedFiles = e.originalEvent.dataTransfer.files;

      // console.log(droppedFiles);
      // droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
      // showFiles( droppedFiles );
      // var ajaxData = new FormData( $form.get( 0 ) );
      // if( droppedFiles )
      // {
      // 	$.each( droppedFiles, function( i, file )
      // 	{
      // 		ajaxData.( $input.attr( 'name' ), file );
      // 	});
      // }

      // $form.trigger( 'submit' ); // automatically submit the form on file drop
    });
});

/* Axios cancel params */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

if (supportsTouch) {
	touchscreenClass = 'is-touchscreen';
}

document.documentElement.classList.add(touchscreenClass);

window.addEventListener('scroll', () => {

	if (!scrollTimeout) {

		scrollTimeout = setTimeout(() => {
			clearTimeout(scrollTimeout);
			scrollTimeout = false;
			scrollPosition = window.scrollY;

			if (0 < scrollPosition) {

				if (scrollPosition > lastScrollPosition) {
					body.classList.remove('scrolling-up');
					body.classList.add('scrolling-down');
				} else {
					body.classList.remove('scrolling-down');
					body.classList.add('scrolling-up');
				}

			} else {
				body.classList.remove('scrolling-down');
				body.classList.remove('scrolling-up');
			}

			lastScrollPosition = 0 >= scrollPosition ? 0 : scrollPosition;
		}, 100);
	}
});

window.addEventListener('resize', () => {
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(() => {
	}, 150);
});

for (let i = 0; i < menuItems.length; i++) {
	let menuItemClassList = Array.from(menuItems[i].classList);
	let menuLink = menuItems[i].firstChild;
	let clonedMenuLink = menuLink.cloneNode(true);
	let newMenuItem = document.createElement('li');
	let childMenu = menuItems[i].querySelector('.sub-menu');

	clonedMenuLink.removeAttribute('id');
	clonedMenuLink.classList.remove('p-3');
	clonedMenuLink.classList.add('dropdown-item', 'px-4', 'py-3', 'p-md-3', 'font-size-lg', 'font-weight-bold', 'bg-border-color');

	newMenuItem.classList.add('menu-item', 'touchscreen-only-md', 'border-bottom-md');

	if (menuItemClassList.includes('current-menu-item')) {
		newMenuItem.classList.add('current-menu-item');
	}

	newMenuItem.appendChild(clonedMenuLink);

	//childMenu.prepend(newMenuItem);
}

siteSearchInput.addEventListener('input', (event) => {

	if (event.target.value) {
		siteSearchReset.classList.remove('opacity-0');
	} else {
		siteSearchReset.classList.add('opacity-0');
	}
});

siteSearchReset.addEventListener('click', () => {
	siteSearchInput.setAttribute('value', '');
	siteSearchReset.classList.add('opacity-0');
});

if (elementsExists(hero)) {
	let nextSibling = document.querySelector('.block-hero').nextElementSibling;

	document.querySelector('.hero-next').addEventListener('click', (event) => {
		const y = nextSibling.getBoundingClientRect().top + window.pageYOffset - headerHeight;

		window.scrollTo({
			top: y,
			behavior: 'smooth'
		});

		event.preventDefault();
	}, false);
}
/*
if (elementsExists(financialDropdown)) {
	if (document.querySelector('.financial-nav .current-page-ancestor > a')) {
		if (window.matchMedia("(max-width: 567px)").matches) {
			document.querySelector('.financial-nav .mobile-collapse').click();
		}

		document.querySelector('.financial-nav .current-page-ancestor > a').click();
	}

	if (!window.matchMedia("(max-width: 567px)").matches) {
		var count = 0;

		const ul = financialDropdown[0].getElementsByTagName('ul')[0];
		const listItems = ul.getElementsByTagName('li');

		for (let i = 0; i <= listItems.length - 1; i++) {
			var elem = listItems[i];

			if (elem.classList.contains('cm-mobile')) {
				count++;
			}
		}

		// Skip first link, hide sub-menu on all-match
		if (count === listItems.length) {
			ul.style.display = 'none';
		}
	}
}
*/
if (elementsExists(carousel)) {
	Flickity.createMethods.push('_createPrevNextCells');

	Flickity.prototype._createPrevNextCells = function () {
		this.on('select', this.setPrevNextCells);
	};

	Flickity.prototype.setPrevNextCells = function () {

		// remove classes
		changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
		changeSlideClasses(this.nextSlide, 'remove', 'is-next');

		// set slides
		var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
		var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
		this.previousSlide = this.slides[previousI];
		this.nextSlide = this.slides[nextI];

		// add classes
		changeSlideClasses(this.previousSlide, 'add', 'is-previous');
		changeSlideClasses(this.nextSlide, 'add', 'is-next');
	};

	function changeSlideClasses(slide, method, className) {

		if (!slide) {
			return;
		}

		slide.getCellElements().forEach(function (cellElem) {
			cellElem.classList[method](className);
		});
	}

	flckty = new Flickity(carousel, {
		adaptiveHeight: true,
		draggable: false,
		cellAlign: 'left',
		arrowShape: 'M57.4392453,58.3779787 L57.3841914,58.3223031 L57.3841914,58.3223031 L48.1702,50 L57.327018,41.731313 C58.1791549,40.9618259 58.2287039,39.6660404 57.4376887,38.837095 L57.3825726,38.7814777 L57.3825726,38.7814777 L57.1467734,38.5670267 C56.3077047,37.8109911 55.0116846,37.8109911 54.1726159,38.5670267 L42.3506525,49.2191056 C41.9073105,49.6185751 41.8808048,50.2920274 42.2914503,50.7233034 L42.3506525,50.7808944 L42.3506525,50.7808944 L54.1726159,61.4329733 C55.0116846,62.1890089 56.3077047,62.1890089 57.1467734,61.4329733 L57.3253394,61.2720779 C58.1783359,60.5034927 58.2293333,59.2077604 57.4392453,58.3779787 Z'
	});
}

if (elementsExists(imageCarousels)) {
	Flickity.createMethods.push('_createPrevNextCells');

	Flickity.prototype._createPrevNextCells = function () {
		this.on('select', this.setPrevNextCells);
	};

	Flickity.prototype.setPrevNextCells = function () {

		// remove classes
		changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
		changeSlideClasses(this.nextSlide, 'remove', 'is-next');

		// set slides
		var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
		var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
		this.previousSlide = this.slides[previousI];
		this.nextSlide = this.slides[nextI];

		// add classes
		changeSlideClasses(this.previousSlide, 'add', 'is-previous');
		changeSlideClasses(this.nextSlide, 'add', 'is-next');
	};

	function changeSlideClasses(slide, method, className) {

		if (!slide) {
			return;
		}

		slide.getCellElements().forEach(function (cellElem) {
			cellElem.classList[method](className);
		});
	}

	imageCarousels.forEach((e) => {
		var carousel = e;
		var imageCarouselNav = e.parentElement.querySelector('.image-carousel-nav');

		e = new Flickity(carousel, {
			adaptiveHeight: false,
			cellAlign: 'left',
			arrowShape: 'M57.4392453,58.3779787 L57.3841914,58.3223031 L57.3841914,58.3223031 L48.1702,50 L57.327018,41.731313 C58.1791549,40.9618259 58.2287039,39.6660404 57.4376887,38.837095 L57.3825726,38.7814777 L57.3825726,38.7814777 L57.1467734,38.5670267 C56.3077047,37.8109911 55.0116846,37.8109911 54.1726159,38.5670267 L42.3506525,49.2191056 C41.9073105,49.6185751 41.8808048,50.2920274 42.2914503,50.7233034 L42.3506525,50.7808944 L42.3506525,50.7808944 L54.1726159,61.4329733 C55.0116846,62.1890089 56.3077047,62.1890089 57.1467734,61.4329733 L57.3253394,61.2720779 C58.1783359,60.5034927 58.2293333,59.2077604 57.4392453,58.3779787 Z',
			pageDots: false
		});

		if (imageCarouselNav) {

			imageCarouselNav = new Flickity(imageCarouselNav, {
				asNavFor: carousel,
				adaptiveHeight: false,
				cellAlign: 'left',
				contain: true,
				prevNextButtons: false,
				pageDots: false
			});

		}

	});
}

if (elementsExists(faqs)) {
	let i = 0;

	for (i = 0; i < faqs.length; i++) {
		let j = 0;
		let question = faqs[i].getElementsByClassName('faq-question');

		for (j = 0; j < question.length; j++) {

			question[j].addEventListener('click', function () {
				var answer = this.nextElementSibling;
				this.parentElement.classList.toggle('show-answer');

				if (answer) {

					if (answer.style.maxHeight) {
						answer.style.maxHeight = null;
					} else {
						answer.style.maxHeight = answer.scrollHeight + 'px';
					}
				}
			});
		}
	}
}

if (elementsExists(odometer) && !supportsTouch) {

	document.addEventListener('lazybeforeunveil', function (e) {

		bounty({
			el: e.target,
			value: e.target.getAttribute('data-odometer-to'),
			initialValue: e.target.getAttribute('data-odometer-from'),
			letterSpacing: 0,
			animationDelay: 600
		});
	});
}

if (elementsExists(rangeSliders)) {

	rangeSliders.forEach(function (slide) {
		var parentParentElement = slide.parentElement.parentElement;
		var prevElement = slide.previousElementSibling;
		var minValue = parseInt(prevElement.getAttribute('min'));
		var maxValue = parseInt(prevElement.getAttribute('max'));
		var rangeStep = 1;

		noUiSlider.create(slide, {
			range: {
				'min': minValue,
				'max': maxValue
			},
			start: [minValue, maxValue],
			margin: 1,
			step: rangeStep,
			connect: true,
			behaviour: 'tap-drag'
		});

		slide.noUiSlider.on('update.one', function (values, handle) {
			var currentMinMaxValues = slide.noUiSlider.get();
			var currentMinValue = Math.min.apply(null, currentMinMaxValues);
			var currentMaxValue = Math.max.apply(null, currentMinMaxValues);

			parentParentElement.querySelector('.min-value').innerHTML = currentMinValue.toLocaleString('sv-SE');
			parentParentElement.querySelector('.max-value').innerHTML = currentMaxValue.toLocaleString('sv-SE');
		});

		slide.noUiSlider.on('set.one', function (values, handle) {
			var currentMinMaxValues = slide.noUiSlider.get();
			var currentMinValue = Math.min.apply(null, currentMinMaxValues);
			var currentMaxValue = Math.max.apply(null, currentMinMaxValues);
		});
	});
}

if (elementsExists(propertyMap)) {
	let map;
	let markers = [];
	let markerCluster

	let locations = [];

	let clusterStyles = [{
		url: ajax.templateUrl + '/assets/dist/images/pin.svg',
		className: 'custom-marker-pin',
		width: 36,
		height: 64
	}];

	let clusterOptions = {
		styles: clusterStyles,
		maxZoom: 15,
	};

	let infowindow = new google.maps.InfoWindow();
	let bounds = new google.maps.LatLngBounds();

	function initMap() {

		map = new google.maps.Map(document.getElementById('property-map'));

		locations = JSON.parse(document.querySelector('#map-data').dataset.mapLatLang);

		if (locations.length) {
			loadMarkers();
		}
	}

	function loadMarkers() {

		markers = locations.map(function (location, i) {

			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(location.lat, location.lng),
				map: map,
				animation: google.maps.Animation.DROP,
				icon: ajax.templateUrl + '/assets/dist/images/pin.svg'
			});

			bounds.extend(marker.position);

			google.maps.event.addListener(marker, 'click', (function (marker) {
				return function () {
					infowindow.setContent(location.address);
					infowindow.open(map, marker);
				}
			})(marker));

			return marker;
		});

		markerCluster = new MarkerClusterer(map, markers, clusterOptions);

		map.fitBounds(bounds);
		map.panToBounds(bounds);

		setTimeout(() => {
			google.maps.event.trigger(map, 'resize');
		}, 2000);
	}

	initMap();

	google.maps.event.addListener(map, "resize", function (e) {
		setTimeout(() => {
			map.fitBounds(bounds);
			map.panToBounds(bounds);
		}, 150);
	});
}

if (elementsExists(objectsList)) {

	const form = document.getElementById("objects-form")
	const formSort = document.getElementById("objects-sorts")

	form.querySelectorAll(".dropdown-menu").forEach(el => {
		el.addEventListener('click', e => {
			e.stopPropagation();
		});
	});

	let forms = [...form.querySelectorAll('input'), ...formSort.querySelectorAll('input')];
	let postType = '';

	forms.forEach(el => {

		if (el.nextElementSibling.classList.contains('range-slide')) {

			el.nextElementSibling.noUiSlider.on('change.one', function () {
				triggerFormSubmit(forms, false)
			});

		} else {
			el.addEventListener(el.type === "text" ? "input" : "change", e => {
				checkUncheckInputsDropDown(e);
				triggerFormSubmit(forms, false);
			})
		}

		if (el.name == "post-type") {
			postType = el.value;
		}

	})

	// Auto sort A-Z on properties
	let auSort = document.getElementById('objects-sort-address-asc');

	if (elementsExists(auSort) && postType == 'property') {
		auSort.checked = true;
		//triggerFormSubmit(forms);
	}

	function checkUncheckInputsDropDown(el) {
		if (!el.currentTarget.closest("#objects-sorts")) {

			const relativeInputs = el.currentTarget.closest('.dropdown').querySelectorAll('input');

			const { all, isEverythingChecked, names } = [...relativeInputs].reduce((acc, input) => {
				const newIsEverythingChecked = input.value === "all"
					? acc.isEverythingChecked
					: input.checked && acc.isEverythingChecked;


				const names = input.checked && input.value !== "all" ? [...acc.names, input.dataset.title] : [...acc.names];

				return {
					...acc,
					all: input.value === "all" ? input : acc.all,
					isEverythingChecked: newIsEverythingChecked,
					names: names

				}
			}, { all: null, isEverythingChecked: true, names: [] });

			setDropDownSelectionNames(el, names);

			if (el.currentTarget.value == 'all') {
				relativeInputs.forEach(input => {
					input.checked = el.currentTarget.checked
				})
			} else {
				all.checked = isEverythingChecked;
			}

		}
	}

	function setDropDownSelectionNames(input, names) {
		const dropDown = input.type == 'change' ? input.currentTarget.closest('.dropdown').querySelector('.button-text') : input;

		if (input.type == 'change') {
			if (input.currentTarget.value != 'all') {
				dropDown.innerHTML = names.join(', ');
			} else {
				dropDown.innerHTML = 'Alla';
			}
		} else {
			dropDown.innerHTML = 'Alla';
		}

		if (!dropDown.innerHTML) {
			dropDown.innerHTML = 'Alla';
		}

	}

	document.querySelector('.reset-filter').addEventListener('click', e => {
		let resetData = [...document.querySelectorAll('input[name=post-type], input[name=post-per-page]')];
		const dropDowns = document.querySelector('.object-filters').querySelectorAll('.button-text');

		dropDowns.forEach(element => {
			setDropDownSelectionNames(element);
		});

		forms.forEach(input => {
			if (input.nextElementSibling.classList.contains('range-slide')) {
				input.nextElementSibling.noUiSlider.reset();
			}

			if (input.closest('.dropdown') && !input.closest("#objects-sorts")) {
				input.checked = false;
			}
		});

		triggerFormSubmit(resetData)
	});

	function triggerFormSubmit(form, jumpstate = true) {
		const dataArray = form

		const reduceData = dataArray.reduce((acc, a) => {

			if (a.value == 'all') {
				return acc
			}

			if (a.type === "checkbox") {
				const existingValue = acc[a.name] || []

				if (a.checked) {
					return { ...acc, [a.name]: [...existingValue, { name: a.dataset.title, value: a.value }] }
				} else {
					return { ...acc, [a.name]: existingValue }
				}

			} else if (a.type === "range") {
				return {
					...acc, [a.name]: {
						min: a.nextElementSibling.noUiSlider.get()[0],
						max: a.nextElementSibling.noUiSlider.get()[1]
					}
				}

			} else if (a.type === "radio") {
				const existingValue = acc[a.name] || []

				if (a.checked) {

					if (a.name == 'objects-sort') {
						return { ...acc, [a.name]: a.value }
					}

					return { ...acc, [a.name]: [...existingValue, a.value] }
				} else {

					return { ...acc, [a.name]: existingValue }
				}
			} else {
				return { ...acc, [a.name]: a.value }
			}

		}, {
			'object-layout': objectsLayout,
			page: filtering ? 1 : page,
			filtering: filtering,
		})

		//console.log(reduceData);

		RequestFiltering(reduceData, jumpstate);
	}

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = document.cookie;
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	function RequestFiltering(filterParams, jumpstate = true) {

		let isCanceled = false;

		if (source) {
			source.cancel('Operation canceled due to new request.')
			isCanceled = true;
		}

		source = axios.CancelToken.source();

		$(".block-objects").LoadingOverlay("show", {
			imageClass: "overlay_loading_icon",
		});

		setCookie('filter_params', JSON.stringify(filterParams), 1);

		const data = {
			is_canceled: isCanceled,
			action: 'filter_objects',
			filter: filterParams,
			nonce: ajax.nonce,
		};

		const url = ajax.url;

		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: Qs.stringify(data),
			url,
			cancelToken: source.token
		};



		axios(options)
			.then(response => {

				$('.cards-objects').html(response.data.html)
				$('.objects-count').html(response.data.foundPosts)
				$('#pagination').html(response.data.pagination)

				initPagination();

				Object.entries(response.data.counts).forEach(([type, value]) => {
					Object.entries(value).forEach(([key, value]) => {
						// let id_key = (type == "municipality" || type == "area") ? '#' + type + '-' + key : '#' + key;

						// let id_key = (type == ['municipality_housing', 'municipality_facility', 'municipality_parking_storage', 'municipality_property'] || type == "area") ? '#' + type + '-' + key : '#' + key;


						let id_key = (type == 'municipality_housing' || type == 'municipality_facility' || type == 'municipality_parking_storage' || type == 'municipality_property' || type == "area") ? '#' + type + '-' + key : '#' + key;


						$(id_key).next('label').find('.count').html(value);

						if (value === 0) {
							$(id_key).parent('.custom-checkbox').addClass('inactive');
						} else {
							$(id_key).parent('.custom-checkbox').removeClass('inactive');
						}
					});
				});

				$(".object-filters .dropdown-menu.show").removeClass('show');
				$(".object-filters .dropdown.show").removeClass('show');

				$(".block-objects").LoadingOverlay("hide", true);

				locations = response.data.locations;

				var element = document.querySelector(".object-filters");

				if (element && jumpstate)
					element.scrollIntoView();

				if (locations) {
					reloadMarkers();
				}

			})
			.catch(error => {
				if (axios.isCancel(error)) {
					console.log(error);
				} else {
					console.log(error.response)
					$(".block-objects").LoadingOverlay("hide", true);

					setTimeout(() => {
						$(".block-objects").LoadingOverlay("show", {
							imageClass: "overlay_loading_icon",
							fontawesome: false,
							progress: false,
							text: error.response.statusText ?? ''
						});
					}, 500);
				}

			});
	}

	$("document").ready(function () {

		window.addEventListener("pageshow", function (event) {

			setTimeout(function () {
				if ($(".block-objects").length) {
					$(".block-objects").LoadingOverlay("hide", true);
				}
				if ($(".news-container").length) {
					$(".news-container").LoadingOverlay("hide", true);
				}
			}, 3000);

			var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
			if (historyTraversal && ((document.location.href.indexOf('lediga-lagenheter') != -1) || (document.location.href.indexOf('hyra-lokal') != -1) || (document.location.href.indexOf('lediga-parkeringar') != -1) || (document.location.href.indexOf('vara-fastigheter') != -1))) {

				var cookieparam = getCookie('filter_params');
				var parseObject = JSON.parse(cookieparam);

				var typedata = [];
				if (parseObject.type) {
					parseObject.type.forEach(function (field) {
						typedata.push(field.name);
					});

					var typestr = typedata.join(',');
					$("#object-types-dropdown .button-text").text(typestr);
				}

				var municipalitydata = [];
				if (parseObject.municipality) {
					parseObject.municipality.forEach(function (field) {
						municipalitydata.push(field.name);
					});

					var municipalitystr = municipalitydata.join(',');
					$("#object-municipality-dropdown .button-text").text(municipalitystr);
				}


				var areadata = [];
				if (parseObject.area) {
					parseObject.area.forEach(function (field) {
						areadata.push(field.name);
					});

					var areastr = areadata.join(',');
					$("#object-areas-dropdown .button-text").text(areastr);
				}

				RequestFiltering(parseObject, true);

			}
		});

		setTimeout(function () {
			if ($(".block-objects").length) {
				$(".block-objects").LoadingOverlay("hide", true);
			}
			if ($(".news-container").length) {
				$(".news-container").LoadingOverlay("hide", true);
			}
		}, 3000);

	});

	function getPaginationNumber() {
		const urlParams = new URLSearchParams(window.location.search);
		var paged = urlParams.get('paged');

		if (!paged) {
			const location = window.location.href;
			let parts = location.split('/');

			parts.forEach(function (e, index) {
				if (Number.isInteger(parseInt(e)) && parts[index - 1] == 'sida') {
					paged = e;
				}
			});
		}

		return paged;
	}

	function initPagination() {

		const paginationLinks = document.querySelectorAll('.page-item');
		let current;
		let page;

		filtering = true;

		paginationLinks.forEach(el => {

			if (el.querySelector('.page-numbers').classList.contains('current')) {
				current = parseInt(el.querySelector('.page-numbers').innerHTML);
			}

			el.addEventListener('click', e => {
				e.preventDefault();

				let clickedPagination = e.currentTarget.querySelector('.page-numbers');
				let href = clickedPagination.href;

				page = parseInt(clickedPagination.innerHTML);

				if (clickedPagination.classList.contains('current')) {
					return;
				}

				if (clickedPagination.classList.contains('next')) {
					page = current + 1
				}

				pagination(page, href);
			});

		});
	}

	function pagination(clickedPage, href) {
		page = clickedPage;
		filtering = false;
		triggerFormSubmit(forms);

		window.history.pushState('', '', href);
	}

	initPagination();

	let paginationNumber = getPaginationNumber();

	if (paginationNumber) {
		pagination(paginationNumber, window.location.href);
	}

	function reorientPagination() {
		pagination(paginationNumber, window.location.href);
	}

	addEventListener('popstate', reorientPagination);

	let mapToggle = document.querySelector('.toggle-objects-map');
	let mapIsToggled = false;

	let map;
	let markers = [];
	let markerCluster

	var locations = [];

	let clusterStyles = [{
		url: ajax.templateUrl + '/assets/dist/images/pin.svg',
		className: 'custom-marker-pin',
		width: 36,
		height: 64
	}];

	let clusterOptions = {
		styles: clusterStyles,
		maxZoom: 15,
	};

	let infowindow = new google.maps.InfoWindow();
	let bounds = new google.maps.LatLngBounds();

	function initMap() {

		map = new google.maps.Map(document.getElementById('objects-map'));
		locations = JSON.parse(document.querySelector('#map-data').dataset.mapLatLang);

		if (locations.length) {
			loadMarkers();
		}
	}

	function loadMarkers() {

		markers = locations.map(function (location, i) {

			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(location.lat, location.lng),
				map: map,
				animation: google.maps.Animation.DROP,
				icon: ajax.templateUrl + '/assets/dist/images/pin.svg'
			});

			bounds.extend(marker.position);

			google.maps.event.addListener(marker, 'click', (function (marker) {
				return function () {
					infowindow.setContent(location.address);
					infowindow.open(map, marker);
				}
			})(marker));

			return marker;
		});

		markerCluster = new MarkerClusterer(map, markers, clusterOptions);

		google.maps.event.trigger(map, 'resize');
	}

	function reloadMarkers() {

		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}

		markers = [];

		markerCluster.clearMarkers();
		loadMarkers();
	}

	initMap();

	google.maps.event.addListener(map, "resize", function (e) {
		setTimeout(() => {
			map.fitBounds(bounds);
			map.panToBounds(bounds);
		}, 150);
	});

	mapToggle.addEventListener('click', (e) => {
		if (!markers.length) {
			alert('Fel: inga koordinater hittades');
			return;
		}

		mapToggle.classList.toggle('is-active');
		objectsMapWrapper.classList.toggle('pb-0');
		objectsMapWrapper.classList.toggle('opacity-0');

		google.maps.event.trigger(map, 'resize');
	});


	if (elementsExists(gridLayoutToggle)) {

		gridLayoutToggle.addEventListener('click', (e) => {

			if ('grid' != objectsLayout) {

				if (!e.currentTarget.classList.contains('is-active')) {
					listLayoutToggle.classList.remove('is-active')
					e.currentTarget.classList.add('is-active');
				}

				objectsLayout = 'grid';
				filtering = false;
				triggerFormSubmit(forms);
			}
		});
	}

	if (elementsExists(listLayoutToggle)) {

		listLayoutToggle.addEventListener('click', (e) => {

			if ('list' != objectsLayout) {

				if (!e.currentTarget.classList.contains('is-active')) {
					gridLayoutToggle.classList.remove('is-active')
					e.currentTarget.classList.add('is-active');
				}

				objectsLayout = 'list';
				filtering = false;
				triggerFormSubmit(forms);
			}
		});
	}
}

if (elementsExists(newsList)) {

	const form = document.getElementById("news-filter");

	let forms = [...form.querySelectorAll('input, select')];

	forms.forEach(el => {
		el.addEventListener(el.type === "text" ? "input" : "change", e => {
			triggerFormSubmit(forms);
		})
	});

	function triggerFormSubmit(form) {

		const dataArray = form;

		const reduceData = dataArray.reduce((acc, a) => {

			if (a.value == 'all') {
				return acc
			}

			if (a.type === "select-one") {
				if (a.value) {
					return {
						...acc,
						[a.dataset.type]: a.value
					}
				} else {
					return { ...acc, [a.name]: existingValue }
				}
			} else {
				return { ...acc, [a.name]: a.value }
			}

		}, {
			page: filtering ? 1 : page,
			filtering: filtering,
		})

		RequestFiltering(reduceData);
	}

	function RequestFiltering(filterParams) {
		let isCanceled = false;

		if (source) {
			source.cancel('Operation canceled due to new request.')
			isCanceled = true;
		}

		source = axios.CancelToken.source();

		$(".news-container").LoadingOverlay("show", {
			imageClass: "overlay_loading_icon",
		});

		const data = {
			is_canceled: isCanceled,
			action: 'filter_posts',
			filter: filterParams,
			nonce: ajax.nonce,
		};

		const url = ajax.url;

		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: Qs.stringify(data),
			url,
			cancelToken: source.token
		};

		axios(options)
			.then(response => {
				console.log(response);

				$('.news-container').html(response.data.html)
				$('#pagination').html(response.data.pagination)

				initPagination();

				var element = document.querySelector(".filter-bar");

				if (element)
					element.scrollIntoView();

				$(".news-container").LoadingOverlay("hide", true);
			})
			.catch(error => {
				if (axios.isCancel(error)) {
					console.log(error);
				} else {
					console.log(error.response)
					$(".news-container").LoadingOverlay("hide", true);

					setTimeout(() => {
						$(".news-container").LoadingOverlay("show", {
							imageClass: "overlay_loading_icon",
							fontawesome: false,
							progress: false,
							text: error.response.statusText ?? ''
						});
					}, 500);
				}

			});
	}

	function initPagination() {

		const paginationLinks = document.querySelectorAll('.page-item');
		let current;
		let page;

		filtering = true;

		paginationLinks.forEach(el => {

			if (el.querySelector('.page-numbers').classList.contains('current')) {
				current = parseInt(el.querySelector('.page-numbers').innerHTML);
			}

			el.addEventListener('click', e => {
				e.preventDefault();

				let clickedPagination = e.currentTarget.querySelector('.page-numbers');
				let href = clickedPagination.href;

				page = parseInt(clickedPagination.innerHTML);

				if (clickedPagination.classList.contains('current')) {
					return;
				}

				if (clickedPagination.classList.contains('next')) {
					page = current + 1
				}

				pagination(page, href);
			});

		});
	}

	function pagination(clickedPage, href) {
		page = clickedPage;
		filtering = false;
		triggerFormSubmit(forms);

		window.history.pushState('', '', href);
	}

	initPagination();

	if (elementsExists(gridLayoutToggle)) {

		gridLayoutToggle.addEventListener('click', (e) => {

			if ('grid' != objectsLayout) {

				if (!e.currentTarget.classList.contains('is-active')) {
					listLayoutToggle.classList.remove('is-active')
					e.currentTarget.classList.add('is-active');
				}

				objectsLayout = 'grid';
				filtering = false;
				triggerFormSubmit(forms);
			}
		});
	}

	if (elementsExists(listLayoutToggle)) {

		listLayoutToggle.addEventListener('click', (e) => {

			if ('list' != objectsLayout) {

				if (!e.currentTarget.classList.contains('is-active')) {
					gridLayoutToggle.classList.remove('is-active')
					e.currentTarget.classList.add('is-active');
				}

				objectsLayout = 'list';
				filtering = false;
				triggerFormSubmit(forms);
			}
		});
	}
}

$(function () {
	$('[data-toggle="tooltip"]').tooltip();

	$('.site-search').on('shown.bs.collapse', () => {
		siteSearchInput.focus();
	});
});

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

$(function () {
	var checkBoxes = $(".custom-control-input");

	checkBoxes.each(function () {
		$(this).checked = false;
		$(this).removeAttr("checked");
	});

	// The area taxonomy has no rewrite, so the term lives in the query string
	// (?area=slug). PHP hands us the slug on the form; url is the fallback.
	var objectsForm = document.getElementById('objects-form');
	var urlParams = new URLSearchParams(window.location.search);

	var currentTerm = (objectsForm && objectsForm.dataset.currentArea)
		|| urlParams.get('area')
		|| window.location.pathname.split('/')[2];

	if (currentTerm) {
		// trigger click, not prop: the change handler updates the dropdown
		// label and re-runs the ajax filter.
		$("#area-" + currentTerm).trigger("click");
	}
	if (getCookie("mmpopup") != "1") {
		$('.mm-popup').addClass('show');
	}

	$('.mm-popup .top img').on('click', function () {
		$('.mm-popup').removeClass('show');
		document.cookie = "mmpopup=1;";
	});


});

//om fortinova fonden page - custom style for the last text block
if ($('.page-template-om-fortinovafonden-php').length == 1) {
	var lastBlock = $('.block.block-text').last();
	lastBlock.addClass('lastblock');
	lastBlock.removeClass('my-5');
	lastBlock.removeClass('my-lg-6');

	lastBlock.find('.text-body').addClass('lastblock-hidetext');
	lastBlock.find('.container').addClass('lastblock-container');
	lastBlock.find('.row').addClass('lastblock-row');
	lastBlock.find('.title').addClass('lastblock-title');


	//I have to put bg white here because otherwise it will get overwritten
	$('.lastblock').attr('style', 'background-color: #fff !important; margin-top: 6rem !important;');

} else {
	var lastBlock = $('.block.block-text').last().removeClass('lastblock');
	lastBlock.find('.text-body').removeClass('lastblock-hidetext');
	lastBlock.find('.container').removeClass('lastblock-container');
	lastBlock.find('.row').removeClass('lastblock-row');
	
}


// -----------------------------------------------------------------------------------------